<template>
  <div class="reader">
    <div class="contentx">
      <p>{{wenzi}}</p>
      <br />
      <b-pagination
        :total="total"
        :current.sync="current"
        :range-before="rangeBefore"
        :range-after="rangeAfter"
        :order="order"
        :size="size"
        :simple="isSimple"
        :rounded="isRounded"
        :per-page="perPage"
        :icon-prev="prevIcon"
        :icon-next="nextIcon"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
      ></b-pagination>
    </div>
    <div class="guanggao">
      <div class="container maxpage">
        <GuanggaoCard adname="阅读器广告"></GuanggaoCard>
      </div>
    </div>
  </div>
</template>

<script>
import GuanggaoCard from "@/components/AdCard.vue";
export default {
  name: "Reader",
  components: {
    GuanggaoCard
  },
  data() {
    return {
      total: 200,
      current: 10,
      perPage: 10,
      rangeBefore: 3,
      rangeAfter: 1,
      order: "",
      size: "",
      isSimple: false,
      isRounded: false,
      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      carousels: [],
      wenzi: `無不高全本正遊會油目。風黨一聽減事長不受致我關發裡，個多怎所；西使生照便務，很客整舉一生不學出的得來我四看，治大候時：怕拿歡四了企一別天試他起口問業飛思視不向陽不有生活究時一然不所該想別名在王中成會情單帶動有別雲天是法。人喜排主科能一國！

叫希變次族大回，李不的議原是教義，小越風出人作。性三有得過這：形引發經提食最；定發共。策顯外火？

她我關稱們那是解金兩告百，能標去，心高望有公真：的以快產立人鄉陸了錢工頭面車沒最達機人定往們主也研者人春……早得克顯高象別在；同行美八戰：一軍媽自維有生現背影認可鄉。要她臺物陽信到孩況葉就好打美說不要：可品童日器者子的中師當臺傳調好車假，國有感話活子一，頭考頭計現有畫然下人情注理結雖功引同、了地境面媽南策……的這市達價究傳視斯一得大景。

時斷去，的個長，有檢想員成，後生生十四……充四式己行座種加一。來車國表就病久明界智。遠起事之？好眾沒目力操不葉雲有。我元舞知事開他有士即市然上型家各寶麼我遊景。布讀界顧紀……我重進我合話？許高了：中究坐活子後系輕位演，在出。

評了步求解多，成別期成不現所在少想形怎一以始言會，亮能例到心不由府洋，陽可假度小代常散體同老合拿。

如應聽文世家保有一馬現來，關合港我友動發世化面的溫蘭兒廣，發小止？

情面合該都任益為者明天合的母久一來日色，發真年上體山公黨有，思成成要力教適人岸足展上門約東、離中外次專病推口可不出念調：言研力確；管畫人園個十？斯線取視流著且稱；依方我兩整路她現能它鄉的不已。獎包角滿讀們不結水裡完的過態，增皮學，活字照包排館中要什口與保願力最的也甚創、之學主後把都夫我現來裡我出但去本成們可認嗎一園主、養角看人長推過而受。

總星試，可強作對算他保蘭小人利來近，處的是，直角成子？口有行際不……往望安可那教，間她在展的語有，第候價！計本線外始年規！專球。

龍下得，師軍之位積子正了功，方上成，唱黨那真合對是民一念……在價風賣！洲打漸包信，山香個考，服眼女的經我不自人小！是和的有新頭也更動局白語人沒……國生濟房來相於路？

人能裡有治；只中速，統學作拉銀熱記多，又裡有……產家母養務來座日設也交不突演去海已師子驚兒；電大上。國主上事好也內在院著傳活品，一個無我活一積青天！

了的車賽星無。合見息房！不低科小量外那經方本以來管他能亞然，看在相去這必得是高發古！案老開有施員保上開不？制懷有社受；代非來母：一經家優升，產機期，總離位產去身果足一政夫關冷……者人康著類其何飛！得眼門度那小色深相國即易和人？關之集常越不戰到快長一中！生小流家國在香想防熱、個有型阿不電樣有經書。有陽神因件科與、有去團，求拉可度市起像的有將，有小叫黃。是觀都說是獨據草已，光節人實回給家不風活進造成竟是都看在幾來地大太商青整的！特的度？

片車清要。了企線外情成論子多形？不出傷一人地千另寫長了設我爭一中明到應！

旅在功呢，易成適研房回感果了新王此一童？

以大友人稱作完引開備斷病度然了華員多道往燈物人受寶圖李緊因無小地。
叫希變次族大回，李不的議原是教義，小越風出人作。性三有得過這：形引發經提食最；定發共。策顯外火？

她我關稱們那是解金兩告百，能標去，心高望有公真：的以快產立人鄉陸了錢工頭面車沒最達機人定往們主也研者人春……早得克顯高象別在；同行美八戰：一軍媽自維有生現背影認可鄉。要她臺物陽信到孩況葉就好打美說不要：可品童日器者子的中師當臺傳調好車假，國有感話活子一，頭考頭計現有畫然下人情注理結雖功引同、了地境面媽南策……的這市達價究傳視斯一得大景。

時斷去，的個長，有檢想員成，後生生十四……充四式己行座種加一。來車國表就病久明界智。遠起事之？好眾沒目力操不葉雲有。我元舞知事開他有士即市然上型家各寶麼我遊景。布讀界顧紀……我重進我合話？許高了：中究坐活子後系輕位演，在出。

評了步求解多，成別期成不現所在少想形怎一以始言會，亮能例到心不由府洋，陽可假度小代常散體同老合拿。

如應聽文世家保有一馬現來，關合港我友動發世化面的溫蘭兒廣，發小止？

情面合該都任益為者明天合的母久一來日色，發真年上體山公黨有，思成成要力教適人岸足展上門約東、離中外次專病推口可不出念調：言研力確；管畫人園個十？斯線取視流著且稱；依方我兩整路她現能它鄉的不已。獎包角滿讀們不結水裡完的過態，增皮學，活字照包排館中要什口與保願力最的也甚創、之學主後把都夫我現來裡我出但去本成們可認嗎一園主、養角看人長推過而受。

總星試，可強作對算他保蘭小人利來近，處的是，直角成子？口有行際不……往望安可那教，間她在展的語有，第候價！計本線外始年規！專球。

龍下得，師軍之位積子正了功，方上成，唱黨那真合對是民一念……在價風賣！洲打漸包信，山香個考，服眼女的經我不自人小！是和的有新頭也更動局白語人沒……國生濟房來相於路？

人能裡有治；只中速，統學作拉銀熱記多，又裡有……產家母養務來座日設也交不突演去海已師子驚兒；電大上。國主上事好也內在院著傳活品，一個無我活一積青天！

了的車賽星無。合見息房！不低科小量外那經方本以來管他能亞然，看在相去這必得是高發古！案老開有施員保上開不？制懷有社受；代非來母：一經家優升，產機期，總離位產去身果足一政夫關冷……者人康著類其何飛！得眼門度那小色深相國即易和人？關之集常越不戰到快長一中！生小流家國在香想防熱、個有型阿不電樣有經書。有陽神因件科與、有去團，求拉可度市起像的有將，有小叫黃。是觀都說是獨據草已，光節人實回給家不風活進造成竟是都看在幾來地大太商青整的！特的度？

片車清要。了企線外情成論子多形？不出傷一人地千另寫長了設我爭一中明到應！

旅在功呢，易成適研房回感果了新王此一童？

以大友人稱作完引開備斷病度然了華員多道往燈物人受寶圖李緊因無小地。
`
    };
  }
};
</script>

<style scoped lang="scss">
@import "../style/variable.scss";
.reader {
  //   margin: 40px 0 0;
  height: 100%;
  display: flex;
  flex-flow: column;
}

.contentx {
  flex: 1 1 auto;

  height: 100%;
  overflow-y: scroll;
  padding: 2em;
  margin-bottom: $height-guanggao + 1em;
}
.guanggao {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.page {
  height: 100%;
}
</style>

